import * as types from './mutations_types'
import store from 'store/index'

export default {
    [types.SET] (state, deal) {
        state.info = deal
        state.info.editable = store.state.profile.member.is_admin || (store.state.profile.member.id === deal.member_id || store.state.profile.member.id === deal.follower_id)
    },
    [types.CLEAR] (state) {
        state.info = {}
    }
}



// WEBPACK FOOTER //
// ./src/modules/deals/components/show/store/mutations.js